import { useUI } from 'store/UI/selectors';
import { useDispatch } from 'react-redux';
import { updateUI } from 'store/UI/actions';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import useStoryViewOpen from 'components/hooks/useStoryViewOpen';
import { isModalOpenByClass } from 'utils/modalCheckByClass';

const usePopUpAtOnce = () => {
  const dispatch = useDispatch();
  const { openPopUpAtOnce } = useUI();
  const showAlert = useAlert();
  const isStoryViewOpen = useStoryViewOpen();

  const checkPopUpAtOnce = () => {
    const domModalOpen = isModalOpenByClass();
    const storyOpen = isStoryViewOpen();
    const hasPopupOpen = openPopUpAtOnce || storyOpen || domModalOpen;
    if (hasPopupOpen) {
      showAlert("Please close the current pop-up before proceeding.", "info");
    }
    return hasPopupOpen;
    // return false;
  };

  const updatePopUpAtOnce = (value: boolean) => {
    dispatch(updateUI({ openPopUpAtOnce: value }));
  };

  return { openPopUpAtOnce, updatePopUpAtOnce, checkPopUpAtOnce };
};

export default usePopUpAtOnce;
